import TagHeader from './tagHeader'

const tagHeader = new TagHeader()
tagHeader.init()
